import SummaryDetails from './SummaryDetails.component';

export default SummaryDetails;
